// CardDetail.jsx
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { gbsConverter } from "../../utils/common";

const CardDetail = ({ icon, bgColor, name, count, size, ext }) => {
  const { user, profile_image, storage } = useSelector(
    (state) => state.userSlice
  );
  // Calculate progress percentage (you can modify this logic based on your needs)
  const usedSize = parseFloat(size);
  const progressPercentage = (usedSize / storage) * 100;
  const { t } = useTranslation();

  return (
    <div className="card-main">
      <div className="card-inner">
        {/* Top Section - Icon and Text */}
        <div className="card-header">
          <div className="card-icon">
            <div className="icon-circle" style={{ backgroundColor: bgColor }}>
              <img src={icon} alt={name + " icon"} />
            </div>
          </div>

          <div className="card-content">
            <div className="card-title">{name}</div>
            <div className="card-subtitle">
              {count} {t(`label.items`)}
            </div>
          </div>
        </div>

        {/* Progress Bar */}
        <div className="progress-section">
          <div className="progress-bar">
            <div
              className="progress-fill"
              style={{
                width: `${Math.min(progressPercentage, 100)}%`,
                backgroundColor: bgColor,
              }}
            ></div>
          </div>
        </div>

        {/* Size Information */}
        <div className="card-desc">{gbsConverter(size)}</div>
      </div>
    </div>
  );
};

export default CardDetail;
